function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPopupPluvio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1, 0, 0, 1, -2.050543, -231.39856)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.26458332
    },
    d: "",
    id: "path260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g35",
    transform: "translate(-73.779254,99.772558)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.622076, 0, 0, 1.600513, 31.563339, -96.083557)",
    id: "g428",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "M 46.74 172.491 C 45.975 171.662 46.063 170.139 46.95 168.847 C 47.847 167.537 48.38 167.47 49.212 168.564 C 50.155 169.805 50.362 171.664 49.643 172.444 C 48.906 173.246 47.456 173.269 46.74 172.491 Z M 34.564 167.319 C 33.497 166.161 34.038 163.377 35.599 161.989 C 36.239 161.419 36.282 161.429 37.12 162.313 C 38.649 163.925 38.941 166.262 37.759 167.424 C 37.07 168.1 35.229 168.041 34.564 167.319 Z M 39.944 159.861 C 31.152 159.672 30.863 159.645 29.82 158.914 C 28.445 157.952 27.767 156.652 27.767 154.979 C 27.767 152.618 29.605 150.366 31.872 149.949 C 32.799 149.777 33.033 149.564 33.214 148.723 C 33.911 145.484 37.448 143.461 40.422 144.604 C 40.883 144.781 41.465 144.573 42.475 143.875 C 43.564 143.12 44.339 142.865 45.874 142.756 C 50.468 142.431 53.717 145.394 53.777 149.967 C 53.793 151.154 53.906 151.316 55.141 151.911 C 58.339 153.454 58.483 157.781 55.389 159.354 C 54.098 160.01 51.218 160.105 39.944 159.861 Z",
    style: {
      fill: "#FFFFFF",
      strokeWidth: 0.264583
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPopupPluvio);
export default __webpack_public_path__ + "static/media/map_popup_pluvio.964d981d91187ef7c82d347841b335c9.svg";
export { ForwardRef as ReactComponent };